import React, { Component } from 'react';

class SchedListMetadata extends Component {
    render() {
        return (
            <div>
                <h2> Listagem de Horários </h2>
                <p>
                    Nesta página encontra uma listagem dos horários previamente gerados.
                </p>
                <h3>Funcionalidades disponíveis</h3>
                <ul className="bulleted-list">
                    <li>Visualizar os horários previamente gerados.</li>
                    <li>Pesquisar na lista de horários</li>
                    <li>Marcar horários como afixados.</li>
                    <li>Selecionar vários horários para aplicação de operações.</li>
                    <li>Descarregar os horários em formato SVG, PNG e PDF.</li>
                    <li>Alterar o critério de ordenação da lista de horários.</li>
                    <li>Alterar o número de horários exibidos por página</li>
                </ul>
            </div>
        );
    }
}
export default SchedListMetadata;



// WEBPACK FOOTER //
// ./src/components/metadata/bussched/SchedListMetadata.js